import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { getSalesPhoneNumber } from '../../../utils/talkToSales';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CallSalesModal = ({
  onBackClick,
  onClose
}) => {
  const {
    phoneNumber,
    countryCode
  } = getSalesPhoneNumber();
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: 550,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose()
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        marginBlockEnd: "800",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.callSales"
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      paddingBlockEnd: "1000",
      children: [/*#__PURE__*/_jsxs("div", {
        "data-test-id": "communication-call-submit-success",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h4",
          marginBlockEnd: "0",
          children: phoneNumber
        }), countryCode && /*#__PURE__*/_jsx(Text, {
          as: "small",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `SharedI18nStrings.countryCodes.${countryCode}`
          })
        })]
      }), /*#__PURE__*/_jsx(Button, {
        marginBlockStart: "200",
        use: "link",
        onClick: onBackClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.backButton"
        })
      })]
    })]
  });
};